import { useQuery } from '@tanstack/react-query';
import { configCenterApi } from '../api/configCenterApi';

/**
 * GET /api/eraf/config-center/categories — 카테고리 목록 (CONFIG_CENTER_READ)
 * queryKey: ['config-center', 'categories']
 */
export function useConfigCategories() {
  return useQuery({
    queryKey: ['config-center', 'categories'],
    queryFn: () => configCenterApi.categories(),
    staleTime: 60_000,
  });
}
